import { Qua007CardIComponent } from './qua007-card-I.component';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { NotificationService } from 'src/app/services/notification.service';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { FormularioService } from 'src/app/services/formulario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { GeneralService } from 'src/app/services/general.service';
import { GeneralComponent } from 'src/app/shared/general.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua007-card-V',
    templateUrl: './qua007-card-V.component.html'
})

export class Qua007CardVComponent extends GeneralComponent implements OnInit {
    apcOP: any[];
    public formulario?: FormGroup;
    public filteredStatusOptions: Observable<DropDownListDTO[]>;
    public filteredRecobrRolosOptions: Observable<DropDownListDTO[]>;
    public filteredFxQualGenOptions: Observable<DropDownListDTO[]>;
    public listStatus?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listRecobrRolos?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxQualGen?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxQualFis?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listStatusOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listRecobrRolosOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxQualGenOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxQualFisOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhas?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listLinhasOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public filteredLinhasOptions: Observable<DropDownListDTO[]>;
    public listCargaTransbordo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listCargaTransbordoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public readonlyRecobrimentosRolo?: boolean;

    public listFxAzulCampoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listFxAzulCampo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();



    public listFxAzUmidade?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxAzUmidadeOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listFxAzTempe?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxAzTempeOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listFxAzTempo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxAzTempoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listFxAzTransbordo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxAzTransbordoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listFxAzGeral?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxAzGeralOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();




    @Output() objTempMax = new EventEmitter();
    @Output() mkCalcIII = new EventEmitter();
    @Output() mkTonLaneHr = new EventEmitter();
    // @ViewChild('txtLinhaDescarga') txtLinhaDescarga: ElementRef;
    @ViewChild('txtRecobrRolos') txtRecobrRolos: ElementRef;
    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Etapa 5', false);
        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Tempo_descarga: [null, []],
                Linha_descarga: [null, []],
                Status_wwb: [null, []],
                Recobrimento_rolos: [null, []],
                Controle_secagem: [null, [Validators.pattern('\^[0-9\;]+$')]],
                // Secador_camara: [null, [Validators.pattern('\([a-zA-Z][0-9]\.[0-9]+[\;]?)+')]],
                Secador_camara: [null, [Validators.pattern('\^([DGC]{1}[0-9]{1}[\\.]{1}[0-9]{2}[A-Z]?)$|([DGC]{1}[0-9]{1}[\\.][0-9]{2}[A-Z]?[;]{1})+([DGC]{1}[0-9]{1}[\\.][0-9]{2}[A-Z]?[;]?)$')]],
                // [Validators.pattern('\^([D]{1}[0-9]{1}[\.]{1}[0-9]{2}[\;]?)+')]],
                Faixa_qualidade_genetica: [null,],
                // Faixa_qualidade_fisica: [null, []],
                Temp_max_trajeto: [null, []],
                Temp_max_total_transporte: [null, []],
                apc_ligado: [null, []],
            });
        }
        else {
            this.step = 'Dados de Controle de Qualidade'
            this.formulario = this.formBuilder.group({




                // antiga parte VI

                Faixa_qualidade_genetica: [null, [Validators.required]],
                Fx_azul_campo: [null, [Validators.required]],
                Fx_azul_umidade: [null, [Validators.required]],

                Fx_azul_tempo_nmonitorado: [null, [Validators.required]],
                Fx_azul_transbordo: [null, [Validators.required]],
                Fx_azul_geral: [null, [Validators.required]],
                Faixa_qualidade_fisica: [null, [Validators.required]],
                Fx_azul_temperatura: [null, [Validators.required]],

            });
        }

        this.readonlyRecobrimentosRolo = false;





    }

    async ngOnInit(): Promise<void> {
        if (this.isComercial || this.isBasica) {

            await this.getLists();
            await this.getListCargaTransbordo();
            await this.setNoApc();
        }
        else {

            await this.getListsPreBasic();
        }



    }


    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    setNoApc() {
        const apc: string = this.formulario.get('apc_ligado')?.value?.trim()?.toUpperCase();
        console.log(apc);
        if (this.isBasica && (apc == null || apc == 'NÃO')) {
            this.readonlyRecobrimentosRolo = false;
            this.formulario.get('apc_ligado')?.setValue('NÃO')
        }
        else if (apc != null && apc == 'SIM') {
            this.readonlyRecobrimentosRolo = true;
        }

    }

    async getListCargaTransbordo(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'carga_transbordo').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listCargaTransbordo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listCargaTransbordoOriginal = this.listCargaTransbordo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async changeApc($event: any) {
        const apc: string = this.formulario.get('apc_ligado')?.value?.trim()?.toUpperCase();
        console.log(apc);

        if (!!apc && apc === 'SIM') {
            this.formulario.get('Recobrimento_rolos').setValue('Automático');
            //this.formulario.get('Recobrimento_rolos').disable();
            this.readonlyRecobrimentosRolo = true;
        } else if (!!apc && apc === 'NÃO') {
            this.readonlyRecobrimentosRolo = false;
            this.formulario.get('Recobrimento_rolos').enable();
            //this.formulario.get('Recobrimento_rolos').setValue('');
            //this.readonlyRecobrimentosRolo = true;
        }

    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    // checkLinhaDescarga(): void {
    //     const linhaDescarga = this.formulario.get('Linha_descarga').value as string;
    //     if (!!linhaDescarga) {
    //         if (Number(linhaDescarga) < 1 || Number(linhaDescarga) > 4) {
    //             // tslint:disable-next-line: max-line-length
    //             this.notificationService.sendNotification('O valor do campo Linha Descarga tem que ser entre 1 até 4', TypeMessage.Personalized, ActionMessage.Info);
    //             this.formulario.get('Linha_descarga').reset();
    //             this.txtLinhaDescarga.nativeElement.focus();
    //         } else {
    //             this.makeCalculationsIII();
    //         }
    //     }
    // }

    async makeCalculationsIII(): Promise<void> {
        this.mkCalcIII.emit();
    }

    async tonLaneHr(): Promise<void> {
        this.mkTonLaneHr.emit();
    }

    async getFormFatData(): Promise<void> {
        this.objTempMax.emit();
    }

    async getLists(): Promise<void> {
        // await Promise.all([this.getListStatus(), this.getListRecobrRolos(), this.getListFxQualGen()]);
        await Promise.all([this.getListStatus(), this.getListLinhas(), this.getListFxQualGen()]);
    }
    async getListsPreBasic() {


        await Promise.all(
            [
                this.getListFxAzulCampo(),
                this.getListFxQualFis(),
                this.getListFxQualGen(),
                this.getListFxAzUmidade(),
                this.getListFxAzTemp(),
                this.getListFxAzTempo(),
                this.getListFxAzTransbordo(),
                this.getListFxAzTGeral()

            ]);
    }
    createFilterStatus(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listStatusOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listStatus = this.listStatusOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listStatus = this.listStatusOriginal;
            }
        } else {
            this.listStatus = this.listStatusOriginal;
        }
    }


    createFilterLinhas(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listLinhasOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listLinhas = this.listLinhasOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listLinhas = this.listLinhasOriginal;
            }
        } else {
            this.listLinhas = this.listLinhasOriginal;
        }
    }

    createFilterRecobrRolos(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listRecobrRolosOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listRecobrRolos = this.listRecobrRolosOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listRecobrRolos = this.listRecobrRolosOriginal;
            }
        } else {
            this.listRecobrRolos = this.listRecobrRolosOriginal;
        }
    }

    createFilterFxQualGen(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxQualGenOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxQualGen = this.listFxQualGenOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxQualGen = this.listFxQualGenOriginal;
            }
        } else {
            this.listFxQualGen = this.listFxQualGenOriginal;
        }
    }


    //   createFilterFxQualFis(value: string): void {

    //     if (!!value && value.length > 0) {
    //         if (this.listFxQualFisOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
    //             this.listFxQualFis = this.listFxQualFisOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
    //         } else {
    //             this.listFxQualFis = this.listFxQualFisOriginal;
    //         }
    //     } else {
    //         this.listFxQualFis = this.listFxQualFisOriginal;
    //     }
    // }


    async getListStatus(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'status_wwb').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listStatus = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listStatusOriginal = this.listStatus;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async getListLinhas(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite()
        await this.formularioService.getListDropDownList('qua007', 'linha_descarga', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listLinhas = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listLinhasOriginal = this.listLinhas;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async getListRecobrRolos(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'recobrimento_rolos').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listRecobrRolos = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listRecobrRolosOriginal = this.listRecobrRolos;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }


    //   async getListFxQualFis(): Promise<void> {

    //     await this.formularioService.getListDropDownList('qua007', 'faixa_qualidade_fisica').pipe(take(1)).toPromise().then((response: any) => {
    //         if (!!response?.data) {
    //             this.listFxQualFis = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
    //             this.listFxQualFisOriginal = this.listFxQualFis;
    //         }
    //     }).catch(async (error: HttpErrorResponse) => {
    //         this.notificationService.showNotificationError(error, error.message);
    //     });
    // }

    private async getListFxAzulCampo(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite()

        await this.formularioService.getListDropDownList('qua007', 'faixa_azul_campo', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxAzulCampo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxAzulCampoOriginal = this.listFxAzulCampo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async getListFxQualFis(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite()
        await this.formularioService.getListDropDownList('qua007', 'faixa_qualidade_fisica', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxQualFis = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxQualFisOriginal = this.listFxQualFis;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    async getListFxQualGen(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'faixa_qualidade_genetica', 'PET').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxQualGen = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxQualGenOriginal = this.listFxQualGen;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    async getListFxAzUmidade(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'faixa_azul_umidade').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxAzUmidade = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxAzUmidadeOriginal = this.listFxAzUmidade;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async getListFxAzTemp(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'faixa_azul_temperatura').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxAzTempe = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    async getListFxAzTempo(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'faixa_azul_tempo').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxAzTempo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxAzTempoOriginal = this.listFxAzTempo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    async getListFxAzTransbordo(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'faixa_azul_transbordo').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxAzTransbordo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxAzTransbordoOriginal = this.listFxAzTransbordo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
    async getListFxAzTGeral(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'faixa_azul_geral').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxAzGeral = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxAzGeralOriginal = this.listFxAzGeral;
            }
        }).catch(async (error: HttpErrorResponse) => {
        })
    }


    createFilterFxQualFis(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxQualFisOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxQualFis = this.listFxQualFisOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxQualFis = this.listFxQualFisOriginal;
            }
        } else {
            this.listFxQualFis = this.listFxQualFisOriginal;
        }
    }
    createFilterFxUmidade(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxAzUmidadeOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxAzUmidade = this.listFxAzUmidadeOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxAzUmidade = this.listFxAzUmidadeOriginal;
            }
        } else {
            this.listFxAzUmidade = this.listFxAzUmidadeOriginal;
        }
    }
    createFilterFxTempo(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxAzTempoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxAzTempo = this.listFxAzTempoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxAzTempo = this.listFxAzTempoOriginal;
            }
        } else {
            this.listFxAzTempo = this.listFxAzTempoOriginal;
        }
    }
    createFilterFxTempe(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxAzTempeOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxAzTempe = this.listFxAzTempeOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxAzTempe = this.listFxAzTempeOriginal;
            }
        } else {
            this.listFxAzTempe = this.listFxAzTempeOriginal;
        }
    }
    createFilterFxTransbordo(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxAzTransbordoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxAzTransbordo = this.listFxAzTransbordoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxAzTransbordo = this.listFxAzTransbordoOriginal;
            }
        } else {
            this.listFxAzTransbordo = this.listFxAzTransbordoOriginal;
        }
    }
    createFilterFxGeral(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxAzGeralOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxAzGeral = this.listFxAzGeralOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxAzGeral = this.listFxAzGeralOriginal;
            }
        } else {
            this.listFxAzGeral = this.listFxAzGeralOriginal;
        }
    }
    async recobrimentoRoloIsValid(): Promise<void> {
        const value: string = this.formulario.get('Recobrimento_rolos')?.value as string ?? '0';
        if (!!value && !this.readonlyRecobrimentosRolo) {
            if (!this.generalService.numberMultipleOf(Number(value), 5)) {
                await this.messageRecobrimentoRoloValidation();
            }
            if (Number(value) > 100) {
                await this.messageRecobrimentoRoloValidation();
            }
        }
    }
    isSemFaixaAzulSelected(): boolean {
        const fxAzulCampoControl = this.formulario.get('Fx_azul_campo')?.value;
        if (Array.isArray(fxAzulCampoControl) && fxAzulCampoControl.includes('Sem Faixa Azul')) {
            this.formulario.get('Fx_azul_campo')?.setValue(['Sem Faixa Azul']);
            return true;
        }
        return false;
    }

    createFilterFxAzulCampo(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxAzulCampoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxAzulCampo = this.listFxAzulCampoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxAzulCampo = this.listFxAzulCampoOriginal;
            }
        } else {
            this.listFxAzulCampo = this.listFxAzulCampoOriginal;
        }

        // this.filteredFxAzulCampoOptions = this.formulario.get('Fx_azul_campo').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listFxAzulCampo, value))
        //     );
    }
    private async messageRecobrimentoRoloValidation(): Promise<void> {
        this.notificationService.sendNotification('O valor inserido deve ser do número 5 até o 100, e com final de 0 ou 5', TypeMessage.Personalized, ActionMessage.Info);
        this.formulario.get('Recobrimento_rolos').reset();
        this.txtRecobrRolos.nativeElement.focus();
    }
}
